//Import required libraries
import React, { useState }  from 'react';
import EditIcon from '@material-ui/icons/Edit';
import * as d3 from 'd3'

//Import custom components
import UploadForm from '../uploadForm/UploadForm'

//Import Styles
import './PicsTable.scss';

//Import Utils
import { addDateToDocs } from '../../../../utils/utils'
import { store } from '../../../../store/initialState'
import picsTableCols from '../../../../assets/data/picsTableCols.json'

let path = store.path

const PicsTable = props => {

    let { docs } = props;

    const [file, setFile] = useState(false);
    const [fileMetaData, setFileMetaData] = useState(null)

    let updDocs;
    if (docs) {
        updDocs = addDateToDocs(docs);
        updDocs = updDocs.slice().sort((a, b) => d3.descending(a.DateTimeOriginal.seconds, b.DateTimeOriginal.seconds))
        console.log(JSON.stringify(updDocs));
    }
    const handleEdit = (fileMetaData) => {
        setFileMetaData(fileMetaData)
    }

    return (
        <>
                <div className='table-container'>
                    <h3 className='table-title'>Uploaded Images</h3>
                    <table>
                        <thead>
                            <tr>
                                {
                                    picsTableCols.map((obj, index) => (
                                    <th key={index}>{obj.label}</th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                updDocs && updDocs.map((obj, index) => {       
                                    return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{obj.pictureId}</td>
                                        <td className='thumbnail-cell'>
                                            <img src={obj.urlCompressed} className='thumbnail'></img>
                                        </td>
                                        <td>{obj.shotOn}</td>
                                        <td>{obj.categoriesDisplay}</td>
                                        <td>{obj.flag}</td>
                                        <td>{obj.device}</td>
                                        <td><EditIcon onClick={() => handleEdit(obj)}
                                                        className='edit-icon'/></td>
                                        <td>{obj.width}</td>
                                        <td>{obj.height}</td>
                                    </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {
                        fileMetaData && <UploadForm setFile={setFile}
                                                    fileMetaData={fileMetaData}
                                                    setFileMetaData={setFileMetaData}/>
                    }
                </div>
        </>
    )
}

export default PicsTable


